export const BlockReason = Object.freeze({
  TooManyNoShows: 0,
  TooManyLateCancellations: 1,
  DamageToPropertyAndFacilities: 2,
  ImpoliteToTheTeamMember: 3,
  TooManyReschedules: 4,
  FakeBookings: 5,
  RefusedToPay: 6,
  Other: 7
})

export const BLOCK_REASON_TO_I18N_KEY_MAP = {
  [BlockReason.TooManyNoShows]: 'customer_profile_block_reason_no_show',
  [BlockReason.TooManyLateCancellations]: 'customer_profile_block_reason_late_cancellation',
  [BlockReason.DamageToPropertyAndFacilities]: 'customer_profile_block_reason_damage',
  [BlockReason.ImpoliteToTheTeamMember]: 'customer_profile_block_reason_impolite',
  [BlockReason.TooManyReschedules]: 'customer_profile_block_reason_many_reschedule',
  [BlockReason.FakeBookings]: 'customer_profile_block_reason_fake_booking',
  [BlockReason.RefusedToPay]: 'customer_profile_block_reason_refuse_pay',
  [BlockReason.Other]: 'customer_profile_block_reason_other'
}
